'use strict';

var message = require('../../../../../../../../../../_virtual/message.cjs');

var hasRequiredMessage;

function requireMessage () {
	if (hasRequiredMessage) return message.__exports;
	hasRequiredMessage = 1;

	var MESSAGE_INTENTIONS = /*#__PURE__*/ function(MESSAGE_INTENTIONS) {
	    MESSAGE_INTENTIONS["neutral"] = "neutral";
	    MESSAGE_INTENTIONS["success"] = "success";
	    MESSAGE_INTENTIONS["critical"] = "critical";
	    MESSAGE_INTENTIONS["warning"] = "warning";
	    MESSAGE_INTENTIONS["info"] = "info";
	    return MESSAGE_INTENTIONS;
	}({});

	message.__exports.MESSAGE_INTENTIONS = MESSAGE_INTENTIONS;
	
	return message.__exports;
}

exports.__require = requireMessage;
//# sourceMappingURL=message.cjs.map
